/* eslint-disable no-alert */
import 'zepto.touch';
import { isWechat } from "mdetect";

import { runPage } from "@shared/scripts/utils/tool";
import getCurrentUser from "@shared/scripts/features/get_current_user";
import wechat from "@shared/scripts/utils/wechat";

import action from "./add_like_action";
import daily from "./daily";
import topic from "./topic";

import {
  switchSharedModal,
  switchComment,
  goComment,
  seeMore,
  switchPostModal,
  switchGraphSortModal,
} from "./page_actions";

const mobile = () => {
  getCurrentUser();
  if (isWechat()) wechat();

  action();

  const $body = $("body");
  const controllerName = $body.data("controller");

  runPage("dailies-show", daily);
  runPage("topics-show", topic);
  runPage(["dailies-show", "topics-show"], switchSharedModal);

  if (/^memberships$/.test(controllerName)) {
    switchPostModal();
    useSwipper();
  }
};

export default mobile;
